var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 17.9117C2.74525 17.9916 3.65289 17.0833 4.44428 17.0833C5.23567 17.0833 6.52045 17.9211 7.22206 17.9117C8.06399 17.9187 9.05017 17.0833 9.99984 17.0833C10.9495 17.0833 11.9357 17.9187 12.7776 17.9117C13.8564 17.9916 14.764 17.0833 15.5554 17.0833C16.3468 17.0833 17.6316 17.9211 18.3332 17.9117",
    stroke: "#272727",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.0833C3.81845 15.6114 2.98572 13.7273 2.63112 12.729C2.51867 12.4124 2.46245 12.2542 2.52774 12.1029C2.59303 11.9516 2.75314 11.8806 3.07336 11.7388L9.31435 8.97436C9.65203 8.82479 9.82087 8.75 10 8.75C10.1791 8.75 10.348 8.82479 10.6856 8.97436L16.9266 11.7388C17.2469 11.8806 17.407 11.9516 17.4723 12.1029C17.5376 12.2542 17.4813 12.4124 17.3689 12.729C17.0143 13.7273 16.1816 15.6114 15 17.0833",
    stroke: "#272727",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.8333L5.17992 8.49431C5.29223 7.03425 5.34839 6.30422 5.82764 5.86042C6.30688 5.41663 7.03907 5.41663 8.50344 5.41663H11.4966C12.9609 5.41663 13.6931 5.41663 14.1724 5.86042C14.6516 6.30422 14.7078 7.03425 14.8201 8.4943L15 10.8333",
    stroke: "#272727",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08301 5.41665L7.22594 4.27323C7.35628 3.23049 7.42145 2.70912 7.7759 2.39622C8.13035 2.08331 8.65578 2.08331 9.70663 2.08331H10.2927C11.3436 2.08331 11.869 2.08331 12.2235 2.39622C12.5779 2.70912 12.6431 3.23049 12.7734 4.27323L12.9163 5.41665",
    stroke: "#272727",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.546260258b1071b65cf579812ee40725.svg";
export { ForwardRef as ReactComponent };